import React from 'react';
import { Link } from 'react-router-dom';
export const Footer = () => {
  return <footer className="bg-primary-700 text-white border-t border-primary-800" data-id="element-160">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8" data-id="element-161">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-162">
          <div className="md:col-span-2" data-id="element-163">
            <h2 className="text-2xl font-heading font-bold text-white" data-id="element-164">
              Toddler Time ATL
            </h2>
            <p className="mt-2 text-gray-200" data-id="element-165">
              The Ultimate Mobile Play Experience for Toddlers in Atlanta
            </p>
            <div className="mt-4" data-id="element-166">
              <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-2" data-id="element-167">
                Service Areas
              </h3>
              <p className="text-sm text-gray-300 leading-relaxed" data-id="element-168">
                Atlanta • Douglasville • Marietta • Decatur • Alpharetta •
                Roswell • Sandy Springs • Smyrna • East Point • College Park •
                Lithia Springs • Austell • Mableton • Powder Springs • Kennesaw
                • Acworth • Lawrenceville • Duluth • Dacula • Buford • Suwanee •
                Johns Creek • Dunwoody • Brookhaven • Chamblee • Norcross •
                Tucker • Stone Mountain • Lilburn • Snellville • Loganville and
                surrounding Metro Atlanta areas
              </p>
            </div>
            <p className="mt-6 text-sm text-gray-300" data-id="element-169">
              © {new Date().getFullYear()} Toddler Time Soft Play Rentals and
              More. All rights reserved.
            </p>
          </div>
          <div data-id="element-170">
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider" data-id="element-171">
              Quick Links
            </h3>
            <ul className="mt-4 space-y-2" data-id="element-172">
              <li data-id="element-173">
                <Link to="/about" className="text-base text-gray-200 hover:text-white hover:underline" onClick={() => window.scrollTo(0, 0)} data-id="element-174">
                  About
                </Link>
              </li>
              <li data-id="element-175">
                <a href="/#services" className="text-base text-gray-200 hover:text-white hover:underline" data-id="element-176">
                  Packages
                </a>
              </li>
              <li data-id="element-177">
                <Link to="/gallery" className="text-base text-gray-200 hover:text-white hover:underline" onClick={() => window.scrollTo(0, 0)} data-id="element-178">
                  Gallery
                </Link>
              </li>
              <li data-id="element-179">
                <Link to="/faq" className="text-base text-gray-200 hover:text-white hover:underline" onClick={() => window.scrollTo(0, 0)} data-id="element-180">
                  FAQ
                </Link>
              </li>
              <li data-id="element-181">
                <Link to="/contact" className="text-base text-gray-200 hover:text-white hover:underline" onClick={() => window.scrollTo(0, 0)} data-id="element-182">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-183">
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider" data-id="element-184">
              Contact
            </h3>
            <ul className="mt-4 space-y-2" data-id="element-185">
              <li data-id="element-186">
                <a href="tel:4702430414" className="text-base text-gray-200 hover:text-white hover:underline" data-id="element-187">
                  (470) 243-0414
                </a>
              </li>
              <li data-id="element-188">
                <a href="mailto:info@toddlertimeatl.com" className="text-base text-gray-200 hover:text-white hover:underline" data-id="element-189">
                  info@toddlertimeatl.com
                </a>
              </li>
              <li className="text-base text-gray-200" data-id="element-190">
                Serving the Greater Atlanta Area
              </li>
            </ul>
            <div className="mt-6 flex space-x-6" data-id="element-191">
              <a href="https://www.facebook.com/toddlertimeatl" className="text-white hover:text-gray-200" target="_blank" rel="noopener noreferrer" data-id="element-192">
                <span className="sr-only" data-id="element-193">Facebook</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-194">
                  <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" data-id="element-195" />
                </svg>
              </a>
              <a href="https://www.instagram.com/toddlertime.softplay?utm_source=ig_web_button_share_sheet&igsh=MWZoOXp3NzVocGg1cg==" className="text-white hover:text-gray-200" target="_blank" rel="noopener noreferrer" data-id="element-196">
                <span className="sr-only" data-id="element-197">Instagram</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-198">
                  <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" data-id="element-199" />
                </svg>
              </a>
              <a href="https://g.co/kgs/C9EXdzq" className="text-white hover:text-gray-200" target="_blank" rel="noopener noreferrer" data-id="element-200">
                <span className="sr-only" data-id="element-201">Google</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-202">
                  <path d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z" data-id="element-203" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};